import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import CustomCard from "../../components/Customsettingscard";
import CustomInput from "../../components/Custominput";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";

export default function Giphy() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.get(
        `${ApiUrl}api/admin/getgifsettings`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setSettings(res.data.data);
        setEnabled(res.data.data.enabled);
      }
    } catch (err) {
      console.log("fetchSettings error:", err);
    } finally {
      setLoading(false);
    }
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem("adminToken");
      //     await axios.post(
      //       `${ApiUrl}api/admin/livestreamsettings`,
      //       settings,
      //       { headers: { Authorization: `Bearer ${token}` } }
      //     );
      //     setSaved(true);
      //     setTimeout(() => setSaved(false), 2000);
      //   } catch (err) {
      //     console.log("saveSettings error:", err);
      //   } finally {
      //     setSaving(false);
      //   }
      // };

      await axios.post(
        `${ApiUrl}api/admin/savegif`,
        { enabled, apiKey: settings.apiKey },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.log("saveSettings error:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      {/* <div className="settings-container"> */}
      <SettingsPageShell wrapperClassName="rr-wrapper-giphy">


        {loading ? (
          <div className="ls-wrapper">
            <p>Loading...</p>
          </div>
        ) : (
          <div className="ls-wrapper-giphy">
            {/* ── Admin Setting Section ── */}
            <div className="ls-section-title">GIPHY</div>

            <div className="ls-note">
              <p>
                *If you turn this On, Users will have GIF options in Chat &
                Comment. *Make sure you have added correct GIPHY keys
                properly.
              </p>
            </div>

            <div className="ls-grid-3">
              {/* Card 1 - GIF Supported toggle */}
              <CustomCard bodyClassName="ls-card">
                <h4>GIF Supported</h4>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={enabled}
                    onChange={(e) => setEnabled(e.target.checked)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </CustomCard>

              {/* Card 2 - API key input */}
              <CustomCard bodyClassName="ls-card">
                <CustomInput
                  label="GIPHY API Key"
                  wrapperClassName=""
                  labelClassName="ls-label"
                  className="ls-input"
                  placeholder="--------------"
                  value={settings.apiKey || ''}
                  onChange={(e) =>
                    setSettings({ ...settings, apiKey: e.target.value })
                  }
                />
              </CustomCard>
            </div>

            {/* Save Button */}
            <button
              className="ls-save-btn"
              onClick={saveSettings}
              disabled={saving}
            >
              {saving ? "Saving..." : saved ? "Saved!" : "Save"}
            </button>
          </div>
        )}
         
      </SettingsPageShell>
    </Layout>
  );
}
